import React, { FC, useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import DataService from '../../services/MisDatosService';
import { useAuthStore as useAuthStoreEroski } from '../../store/AuthContext';
import useAPIError from '../../hooks/useAPIError';
import { StorageHelper } from '../../utils/StorageHelper';
import { MisDatosHelper } from './MisDatosHelper';
import { HostProvider } from '../../utils/HostProvider';

// import IconAsterRojo from '../../Icons/IconAsterRojo';

interface Props {
  tipo: boolean;
}

const Subcriptions: FC<Props> = (props) => {
  const { tipo } = props;
  const dataUser = useAuthStoreEroski();
  const { t } = useTranslation();
  const [isInfoCorreo, setIsInfoCorreo] = useState<boolean>(false);
  const [isInfoEmail, setsInfoEmail] = useState<boolean>(false);
  const [isInfoTelefono, setIsInfoTelefono] = useState<boolean>(false);
  const [isInfoSms, setIsInfoSms] = useState<boolean>(false);
  const [load, setLoad] = useState<boolean>(false);
  const [save, setSave] = useState<boolean>(false);
  const { addErrorBack } = useAPIError();
  const isCaprabo = HostProvider.isCaprabo();
  const isEroski = HostProvider.isEroski();

  const getData = () => {
    DataService.subscripciones().then((response: AxiosResponse) => {
      const { pojo } = response.data;
      if (pojo) {
        setIsInfoCorreo(pojo.infoCorreo);
        setsInfoEmail(pojo.infoEmail);
        setIsInfoTelefono(pojo.infoTelefono);
        setIsInfoSms(pojo.infoSms);
        setLoad(true);
      }
    });
  };

  useEffect(() => {
    if (dataUser.user.token !== '') if (!load) getData();
  }, [load, dataUser.user.token]);

  useEffect(() => {
    if (load) {
      const padre = document.getElementById(
        `datos__bloque-suscripciones`,
      ) as HTMLDivElement;
      const scrollSuscripciones = StorageHelper.getScrollSuscripciones() as string;
      if (
        padre !== null &&
        scrollSuscripciones !== null &&
        scrollSuscripciones !== undefined
      ) {
        const misDatosHelper = new MisDatosHelper();
        misDatosHelper.scrollToResponsive(padre);
        StorageHelper.removeScrollSuscripciones();
      }
    }
  });

  useEffect(() => {
    if (save) {
      DataService.updateSubscripciones({
        infoCorreo: isInfoCorreo,
        infoEmail: isInfoEmail,
        infoTelefono: isInfoTelefono,
        infoSms: isInfoSms,
      }).then((response) => {
        if (response.data.error) {
          addErrorBack(response.data);
        } else {
          setSave(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [save]);

  const handlerChange = (
    value: React.ChangeEvent<HTMLInputElement>,
    key: string,
  ) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'isInfoCorreo':
        setIsInfoCorreo(value.target.checked);
        break;
      case 'isInfoEmail':
        setsInfoEmail(value.target.checked);
        break;
      case 'isInfoTelefono':
        setIsInfoTelefono(value.target.checked);
        break;
      case 'isInfoSms':
        setIsInfoSms(value.target.checked);
        break;
    }
    setSave(true);
  };
  console.log('isEroski: ', isEroski);
  console.log('isCaprabo: ', isCaprabo);
  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              <div className="divider" />
              <div className="bloque-datos" id="datos__bloque-suscripciones">
                <h2 className="bloque-datos__title u-text-brand">
                  <span className="divider__square brand-color" />
                  <span className="u-margin-right">
                    {t('datos.suscripciones.title')}
                  </span>
                </h2>

                <div className="bloque-datos__datos">
                  <p className="u-margin-bottom">
                    {tipo
                      ? t('datos.suscripciones.caprabo_subtitle')
                      : t('datos.suscripciones.subtitle')}
                  </p>

                  <form className="check-options">
                    <fieldset>
                      {/* <div className="checkbox checkbox--inline u-margin-right"> */}
                      <label
                        htmlFor="correo"
                        className={`checkgroup ${
                          dataUser.user.adicional ? 'disabled' : ''
                        }`}
                      >
                        {t('datos.suscripciones.postal-email-option')}
                        <input
                          type="checkbox"
                          id="correo"
                          className="form-control"
                          disabled={dataUser.user.adicional}
                          checked={isInfoCorreo}
                          onChange={(e) => handlerChange(e, 'isInfoCorreo')}
                        />
                        <span className="checkmark" />
                      </label>

                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="mail" className="checkgroup">
                        {t('datos.suscripciones.email-option')}
                        <input
                          type="checkbox"
                          id="mail"
                          className="form-control"
                          checked={isInfoEmail}
                          onChange={(e) => handlerChange(e, 'isInfoEmail')}
                        />
                        <span className="checkmark" />
                      </label>

                      {isCaprabo && (
                        <label
                          htmlFor="telefono"
                          className={`checkgroup ${
                            dataUser.user.adicional ? 'disabled' : ''
                          }`}
                        >
                          {t('datos.suscripciones.phone-option')}
                          <input
                            type="checkbox"
                            id="telefono"
                            disabled={dataUser.user.adicional}
                            className="form-control"
                            checked={isInfoTelefono}
                            onChange={(e) => handlerChange(e, 'isInfoTelefono')}
                          />
                          <span className="checkmark" />
                        </label>
                      )}

                      {isEroski && (
                        <label htmlFor="sms" className="checkgroup">
                          {t('datos.suscripciones.phone-option')}
                          <input
                            type="checkbox"
                            id="sms"
                            className="form-control"
                            checked={isInfoTelefono}
                            onChange={(e) => handlerChange(e, 'isInfoTelefono')}
                          />
                          <span className="checkmark" />
                        </label>
                      )}
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="check-two" className="checkgroup">
                        {t('datos.suscripciones.sms-option')}
                        <input
                          type="checkbox"
                          id="check-two"
                          className="form-control"
                          checked={isInfoSms}
                          onChange={(e) => handlerChange(e, 'isInfoSms')}
                        />
                        <span className="checkmark" />
                      </label>
                    </fieldset>
                  </form>
                </div>
              </div>
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default Subcriptions;
